import React, { useEffect } from "react";
import "./workout.css";
import workingout from "../../assets/yogawom.png";
import firstw from "../../assets/trimwrk1.png";
import secondw from "../../assets/trimwrk2.jpeg";
import thirdw from "../../assets/trimwrk3.jpeg";

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function Workout({selectedTool, setSelectedTool}) {
  useEffect(() => {
    setSelectedTool("/exercise ");
  }, []);

  return (
    <div className="wrk-base">
      <Helmet>
        <title>
          Pregnancy Workouts: Safe Workouts for Every Stage of Pregnancy
        </title>
        <meta
          name="description"
          content="Try effective pregnancy exercises that promote your well-being and nourish your body. Experience a healthier, more comfortable pregnancy journey. "
        />
        <meta
          name="keywords"
          content="Safe pregnancy workouts, pregnancy yoga, exercise during pregnancy"
        />
      </Helmet>
      <div className="wrk-main">
        <div
          className="bread-container"
          style={{ position: "absolute", top: "0", left: "0" }}
        >
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link to="/" className="breadcrumb-link" onClick={()=>setSelectedTool("")}>
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/tools" className="breadcrumb-link">
                  Tools
                </Link>
              </li>
              <li className="breadcrumblist active">Exercises</li>
            </ol>
          </nav>
        </div>

        <div id="inside-wrk">
          <div className="wrk-image">
            <img src={workingout} alt="wrk-woman" />
          </div>
          <div className="wrk-cont">
            <h2 className="wrk-heading">Exercise for Moms</h2>
            <h4 className="wrk-subheading">
              Trimester Exercises upto 3rd Trimesters
            </h4>
          </div>
        </div>
      </div>

      <div className="wrk-main2">
        <div className="box-wrk">
          <Link to="exercise-1">
            <img src={firstw} alt="wrk_First" />
            <h3 style={{ color: "white", marginBottom: "-20px" }}>
              First Trimester
            </h3>
          </Link>
        </div>

        <div className="box-wrk">
          <Link to="exercise-2">
            <img src={secondw} alt="wrk_Second" />
            <h3 style={{ color: "white" }}>Second Trimester</h3>
          </Link>
        </div>
        <div className="box-wrk">
          <Link to="exercise-3">
            <img src={thirdw} alt="wrk_Third" />
            <h3 style={{ color: "white" }}>Third Trimester</h3>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Workout;
